export default __webpack_public_path__ + "static/jonh-251af9c96fbb6d03638bc9d6cf665b90.jpg";